module.exports = __webpack_public_path__ + "img/bus.58590ae8.svg";